import React from 'react';
import { Typography, Box } from '@mui/material';

interface BrandLogoProps {
  variant?: 'h3' | 'h4' | 'h5' | 'h6';
  showTagline?: boolean;
}

const BrandLogo: React.FC<BrandLogoProps> = ({ variant = 'h4', showTagline = false }) => {
  return (
    <Box>
      <Typography
        variant={variant}
        fontWeight={800}
        sx={{
          letterSpacing: '-0.5px',
          '& span:first-of-type': {
            color: '#214F80',  // Teal - matches 'e' in logo
          },
          '& span:last-of-type': {
            color: '#C6602F',  // Navy - matches 'f' in logo
          }
        }}
      >
        <span>Extract</span><span>Fast</span>
      </Typography>
      {showTagline && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          AI-Powered Bank Statement Extraction
        </Typography>
      )}
    </Box>
  );
};

export default BrandLogo;